/* ADD Knowledge categories */
export const ADD_LEVEL = "ADD_LEVEL"
export const ADD_LEVEL_SUCCESS = "ADD_LEVEL_SUCCESS"
export const ADD_LEVEL_CLEAN = "ADD_LEVEL_CLEAN"
export const ADD_LEVEL_ERROR = "ADD_LEVEL_ERROR"
